import { useEffect, useState } from 'react';

import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

import { useConfig, useFetchCategory } from '@kega/sps-core';

import useCurrentCategory from '../../hooks/useCurrentCategory';
import useTranslatePath from '../../hooks/useTranslatePath';

import fetchIndexData from '../../modules/algolia/api/fetchIndexData.js';
import { default as ProductListModule } from '../../modules/algolia/ProductList.js';

const fetchData = async (category_key, storeCode, index) => {
    try {
        const algoliaConfig = {
            filters: `code:${category_key}`,
        };

        const result = await fetchIndexData({ indexName: index + '-category-' + storeCode, params: algoliaConfig });

        return result?.results[0]?.hits[0] || {};

    } catch (err) {
        console.log(err);
    }
}

const ProductListPage = () => {
    const [ categoryPLP, setCategoryPLP ] = useState(null);
    const config = useConfig();
    const { category_key } = useParams();

    const { match } = useCurrentCategory(category_key);
    const { fetchCategory, category } = useFetchCategory();
    const { getPath, urlPathWithoutStore } = useTranslatePath();

    const baseUrl = config.get('baseUrl');
    const storeViews = config.get('storeViews');
    const storeCode = config.get('storeCode');
    const { index } = config.get('algolia');

    useEffect(() => {
        if (category_key) {
            fetchCategory({ category_code: category_key });

            const fetchCategoryData = async () => {
                const categoryData = await fetchData(category_key, storeCode, index);
                setCategoryPLP(categoryData);
            };

            fetchCategoryData();

        }
    }, [category_key]);

    return (
        <>
            <Helmet>
                <title>{category?.seoTitleHs ? category.seoTitleHs : category?.name}</title>
                <meta name="description" content={category ? category?.seoMetaDescriptionHs?.replace(/<\/?[^>]+(>|$)/g, "") : ' '} />
                
                <link rel="canonical" href={`${baseUrl}${getPath(category?.url)}`} />

                {
                    storeViews
                    &&
                    Object.keys(storeViews).map((storeCode) => {
                        const href = '/' + storeCode + '/' + urlPathWithoutStore;
                        const lang = storeCode.split('_')[0] === 'be' ? storeCode.split('_').reverse().join('-') : storeCode.split('_').join('-');

                        return <link key={href} rel="alternate" hrefLang={ lang } href={window.location.origin + href} />
                    })
                }

            </Helmet>

            <ProductListModule
                title={category?.name}
                description={category?.introductionHs}
                filters={'allCategoryCodes:"' + category_key + '"'}
                level={(match?.level ? match.level : 0 )}
                categoryText={categoryPLP?.categoryTextPlp}
                url= {category?.url}
                categoryData={categoryPLP}
            />
        </>
    )
}

export default ProductListPage;